"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFourCoordinatesFromPoint = exports.removeConsecutiveDuplicatePoints = void 0;
/* eslint-disable */
/**
 * Most of the code in this file is converted from
 * map product web service to generate the geojson products
 */
const Bezier = require("bezier-js");
const lodash_1 = require("lodash");
const helpers_1 = require("@turf/helpers");
const line_to_polygon_1 = __importDefault(require("@turf/line-to-polygon"));
const boolean_clockwise_1 = __importDefault(require("@turf/boolean-clockwise"));
const boolean_contains_1 = __importDefault(require("@turf/boolean-contains"));
const boolean_point_in_polygon_1 = __importDefault(require("@turf/boolean-point-in-polygon"));
const point_to_line_distance_1 = __importDefault(require("@turf/point-to-line-distance"));
const intersect_1 = __importDefault(require("@turf/intersect"));
const area_1 = __importDefault(require("@turf/area"));
const helper_1 = require("../config/helper");
const lodash_2 = require("lodash");
class GeoJsonUtils {
    getLineStrings(geometryShape, isArea) {
        const MOVE_TO = 0;
        const LINE_TO = 1;
        const QUAD_TO = 2;
        const CUBE_TO = 3;
        const CLOSE = 4;
        let lineString = [];
        let mLineStrings = [];
        let areaClosed = false;
        let prevPoint = null;
        for (let i = 0; i < geometryShape.length; i += 1) {
            const segment = geometryShape[i];
            const segmentType = geometryShape[i][0];
            switch (segmentType) {
                case MOVE_TO: {
                    if (isArea && lineString.length !== 0 && !areaClosed) {
                        if (lineString.length > 0 && !(0, lodash_1.isEqual)(lineString[0], lineString[geometryShape.length - 1])) {
                            lineString.push([geometryShape[0][1], geometryShape[0][2]]);
                        }
                        areaClosed = true;
                        mLineStrings.push(lineString);
                    }
                    const point = [geometryShape[i][1], geometryShape[i][2]];
                    lineString.push(point);
                    prevPoint = point;
                    areaClosed = false;
                    break;
                }
                case LINE_TO: {
                    const point = [geometryShape[i][1], geometryShape[i][2]];
                    if (!(0, lodash_1.isEqual)(point, prevPoint)) {
                        lineString.push(point);
                        prevPoint = point;
                    }
                    // if this is the last segment in path, push it to final array
                    if (i === geometryShape.length - 1) {
                        mLineStrings.push(lineString);
                        lineString = [];
                    }
                    break;
                }
                case QUAD_TO: {
                    const qCurve = new Bezier(prevPoint[0], prevPoint[1], segment[1], segment[2], segment[3], segment[4]);
                    const reducedCurve = qCurve.getLUT(7);
                    let flattenedPoints = [prevPoint];
                    if (reducedCurve.length > 0) {
                        const subDividedPoints = reducedCurve.map((quadCurveSegment) => [quadCurveSegment.x, quadCurveSegment.y]);
                        flattenedPoints = flattenedPoints.concat(subDividedPoints);
                    }
                    if (flattenedPoints.length > 0) {
                        prevPoint = flattenedPoints[flattenedPoints.length - 1];
                        lineString.push(...flattenedPoints);
                    }
                    // if this is the last segment in path, push it to final array
                    if (i === geometryShape.length - 1) {
                        mLineStrings.push(lineString);
                        lineString = [];
                    }
                    break;
                }
                case CUBE_TO: {
                    const bCurve = new Bezier(prevPoint[0], prevPoint[1], segment[1], segment[2], segment[3], segment[4], segment[5], segment[6]);
                    const reducedCurve = bCurve.getLUT(7);
                    let flattenedPoints = [prevPoint];
                    if (reducedCurve.length > 0) {
                        const subDividedPoints = reducedCurve.map((cubeCurveSegment) => [cubeCurveSegment.x, cubeCurveSegment.y]);
                        flattenedPoints = flattenedPoints.concat(subDividedPoints);
                    }
                    if (flattenedPoints.length > 0) {
                        prevPoint = flattenedPoints[flattenedPoints.length - 1];
                        lineString.push(...flattenedPoints);
                    }
                    // if this is the last segment in path, push it to final array
                    if (i === geometryShape.length - 1) {
                        mLineStrings.push(lineString);
                        lineString = [];
                    }
                    break;
                }
                case CLOSE:
                    if (lineString.length > 0 && !(0, lodash_1.isEqual)(lineString[0], lineString[lineString.length - 1])) {
                        lineString.push(lineString[0]);
                    }
                    mLineStrings.push(lineString);
                    lineString = [];
                    prevPoint = null;
                    areaClosed = true;
                    break;
                default:
                    break;
            }
        }
        // validate line string number of points
        const minNumberPoints = isArea ? 4 : 2;
        for (let i = 0; i < mLineStrings.length; i += 1) {
            if (mLineStrings[i].length < minNumberPoints) {
                console.error('Incorrect point count for line string');
            }
        }
        return mLineStrings;
    }
    determineHoles(mLineStrings) {
        const processedLineStrings = {};
        const lineStringsCount = mLineStrings.length;
        let poly1;
        let poly2;
        for (let i = 0; i < lineStringsCount; i += 1) {
            poly1 = mLineStrings[i];
            if (!processedLineStrings[i]) {
                processedLineStrings[i] = {
                    index: i,
                    lineString: poly1,
                };
            }
            if (!processedLineStrings[i].containedBy) {
                processedLineStrings[i].containedBy = [];
            }
            for (let j = 0; j < lineStringsCount; j += 1) {
                if (j !== i) {
                    poly2 = mLineStrings[j];
                    if (!processedLineStrings[j]) {
                        processedLineStrings[j] = {
                            index: j,
                            lineString: poly2,
                        };
                    }
                    if (!processedLineStrings[j].containedBy) {
                        processedLineStrings[j].containedBy = [];
                    }
                    // if (this.isContainedBy(poly2, poly1)) {
                    if ((0, boolean_contains_1.default)((0, line_to_polygon_1.default)((0, helpers_1.lineString)(poly1)), (0, line_to_polygon_1.default)((0, helpers_1.lineString)(poly2)))) {
                        processedLineStrings[j].containedBy.push({
                            index: i,
                            lineString: poly1,
                        });
                    }
                }
            }
        }
        // set the holes & parent
        const processedLineStringsValues = Object.values(processedLineStrings);
        for (let i = 0; i < processedLineStringsValues.length; i += 1) {
            // for (const [i, value] of Object.entries(processedLineStrings)) {
            const order = processedLineStringsValues[i].containedBy.length;
            const isHole = (order % 2 !== 0);
            if (isHole) {
                for (let j = 0; j < processedLineStringsValues[i].containedBy.length; j += 1) {
                    if (order - processedLineStringsValues[processedLineStringsValues[i].containedBy[j].index].containedBy.length === 1) {
                        processedLineStringsValues[i].parent = processedLineStringsValues[processedLineStringsValues[i].containedBy[j].index];
                        processedLineStringsValues[i].hole = true;
                        break;
                    }
                }
            }
        }
        return processedLineStrings;
    }
    isContainedBy(polygon2, outerPolygon) {
        if (polygon2.length === 0) {
            return false;
        }
        const firstPoint = outerPolygon[0];
        return this.isInside(firstPoint, outerPolygon);
    }
    isInside(polygonPoint, polygon) {
        let isInside = false;
        let startPoint = null;
        let previousPoint = null;
        for (let i = 0; i < polygon.length; i += 1) {
            const currentPoint = polygon[i];
            if (startPoint === null) {
                startPoint = currentPoint;
            }
            if (previousPoint !== null) {
                if (this.pointIntersectsLine(polygonPoint, currentPoint, previousPoint)) {
                    isInside = !isInside;
                }
            }
            previousPoint = currentPoint;
        }
        return isInside;
    }
    pointIntersectsLine(refPoint, p1, p2) {
        const x0 = refPoint[0];
        const y0 = refPoint[1];
        const x1 = p1[0];
        const y1 = p1[1];
        const x2 = p2[0];
        const y2 = p2[1];
        if (x1 === x2) {
            return false;
        }
        const xfractionalIntercept = (x0 - x1) / (x2 - x1);
        if ((xfractionalIntercept >= 0) && (xfractionalIntercept < 1)) {
            const yintercept = (y2 - y1) * xfractionalIntercept + y1;
            // y intercept is less that y value - count this as intersection
            // y intercept is above y value - count this as not an intercept
            return yintercept > y0;
        }
        // x intercept is outside of line segment
        return false;
    }
    polygonsIntersect(polygon1, polygon2) {
        const multiPolygon2 = (0, helpers_1.multiPolygon)(polygon2);
        let intersects = false;
        for (let i = 0; i < polygon1.length; i += 1) {
            for (let j = 0; j < polygon1[i].length; j += 1) {
                for (let k = 0; k < polygon1[i][j].length; k += 1) {
                    intersects = (0, boolean_point_in_polygon_1.default)(polygon1[i][j][k], multiPolygon2);
                    if (intersects) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    static isOutsideMultipolygon(feature, outline, outlineAsLine) {
        // Still check further the features whose reference points are outside;
        // to avoid centroid-issues caused by curved lines, accept if even 1 geometry point is inside
        if (feature.geometry.type === 'MultiPolygon' || feature.geometry.type === 'Polygon') {
            // consider polygons being out, if their intersection with the given outline is null or small
            // - provided they have an area (i.e. are not line-like polygons whose intersection is empty)
            const fArea = (0, area_1.default)(feature.geometry);
            if (fArea > 0) {
                let intsect = null;
                try {
                    intsect = (0, intersect_1.default)(feature.geometry, outline);
                }
                catch (error) {
                    // E.g. in map 26133 intersect crashes (max stack size exceeded)
                    if (feature.referencePoint && !(0, boolean_point_in_polygon_1.default)(feature.referencePoint, outline)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                if (!intsect) {
                    return true;
                }
                const intsectArea = (0, area_1.default)(intsect);
                if (fArea > 2 * intsectArea) {
                    // more than 50% of the feature is outside => consider it to be outside
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (feature.referencePoint && !(0, boolean_point_in_polygon_1.default)(feature.referencePoint, outline)) {
                return true;
            }
        }
        else if (feature.referencePoint && !(0, boolean_point_in_polygon_1.default)(feature.referencePoint, outline)) {
            // Note: Micello does not generate MultiLineStrings
            // We want array of positions/points
            const featurePoints = (feature.geometry.type === 'Point' ? [feature.geometry.coordinates] : feature.geometry.coordinates);
            const pointsOutside = featurePoints.filter((point) => !(0, boolean_point_in_polygon_1.default)({ type: 'Point', coordinates: point }, outline));
            if (pointsOutside.length >= 0) {
                // Some of the geometry points of the feature seem to be outside the site geometry.
                // The check using booleanPointInPolygon seems to fail sometimes even if a point is on site outline.
                // To confirm, check their distance to every line representation of the outline.
                if (feature.properties.featureType === 'indoor.Space'
                    && feature.properties.spaceType === 'DOOR'
                    && feature.geometry.coordinates.length > 2) {
                    // Special case: doors with opening angle should be kept in the indoor level if any point is inside.
                    // booleanPointInPolygon can return false and pointToLineDistance gives 0 for the same point !?
                    if (outlineAsLine.some((outlineOfOnePolygon) => featurePoints.some((point) => {
                        const dist = (0, point_to_line_distance_1.default)(point, { coordinates: outlineOfOnePolygon, type: 'LineString' }, { units: 'centimeters' });
                        if (dist < 10) {
                            return true;
                        }
                        return false;
                    }))) {
                        // is inside
                        return false;
                    }
                    return true;
                }
                if (outlineAsLine.every((outlineOfOnePolygon) => pointsOutside.some((point) => {
                    const dist = (0, point_to_line_distance_1.default)(point, { coordinates: outlineOfOnePolygon, type: 'LineString' }, { units: 'centimeters' });
                    if (dist > 50) {
                        // if any point is > 50 cm from the polygon, the whole feature is considered to be outside
                        return true;
                    }
                    return false;
                }))) {
                    // is outside
                    return true;
                }
            }
        }
        return false;
    }
    static orientPolygon(coordinates) {
        let processedCoords = coordinates;
        for (let i = 0; i < coordinates.length; i += 1) {
            let needRewind;
            if (i === 0) {
                needRewind = !(0, boolean_clockwise_1.default)((0, helpers_1.lineString)(coordinates[i]));
            }
            else {
                needRewind = (0, boolean_clockwise_1.default)((0, helpers_1.lineString)(coordinates[i]));
            }
            if (needRewind) {
                processedCoords[i] = coordinates[i].reverse();
            }
        }
        return processedCoords;
    }
    static orientMultiPolygon(coordinates) {
        return coordinates.map((coordinates) => GeoJsonUtils.orientPolygon(coordinates));
    }
    static getRingOrientation(ring) {
        if (ring.length < 4) {
            throw new Error(`Illegal length ring! ring.length=${ring.length} < 4`);
        }
        let totalAngle = 0;
        let prevPointSet = false;
        let prevHeadingSet = false;
        let intPrevLat = 0;
        let intPrevLon = 0;
        let prevHeading = 0;
        let initialHeadingSet = false;
        let initialHeading = 0;
        // we are doing heading in lat lon space, which is not physical space, but
        // that is ok for calculating winding number
        for (let ic = 0; ic < ring.length; ic += 1) {
            const coord = ring[ic];
            // let intLon = Number(coord[0].toFixed(2)) * 100;
            // let intLat = Number(coord[1].toFixed(2)) * 100;
            const intLon = coord[0] * (10 ** 7);
            const intLat = coord[1] * (10 ** 7);
            if (prevPointSet) {
                // ignore a repeated point
                if ((intLon === intPrevLon) && (intLat === intPrevLat)) {
                    continue;
                }
                const heading = GeoJsonUtils.toDegrees(Math.atan2(intLat - intPrevLat, intLon - intPrevLon));
                if (prevHeadingSet) {
                    const turnAngle = GeoJsonUtils.normalizePathHeading(heading - prevHeading);
                    totalAngle += turnAngle;
                }
                prevHeading = heading;
                prevHeadingSet = true;
                if (!initialHeadingSet) {
                    initialHeading = heading;
                    initialHeadingSet = true;
                }
            }
            intPrevLat = intLat;
            intPrevLon = intLon;
            prevPointSet = true;
        }
        // get the change of heading back to the start.
        const finalTurnAngle = GeoJsonUtils.normalizePathHeading(initialHeading - prevHeading);
        totalAngle += finalTurnAngle;
        const windingNumber = totalAngle / 360.0;
        // make sure we are near 360
        const tol = 0.01;
        if (Math.abs(windingNumber - 1) < tol) {
            // positive winding number in lat long space is counter clockwise
            return false;
        }
        if (Math.abs(windingNumber + 1) < tol) {
            // positive winding number in lat long space is clockwise
            return true;
        }
        throw new Error(`Bad winding number: windingNumber=${windingNumber}`);
    }
    static normalizePathHeading(angle) {
        if (angle === 180) {
            throw new Error('Illegal path - doubles back on self!');
        }
        while (angle > 180) {
            angle -= 360;
        }
        while (angle < -180) {
            angle += 360;
        }
        return angle;
    }
    static reverseRing(ring) {
        return ring.reverse();
    }
    static toDegrees(radians) {
        return radians * (180 / Math.PI);
    }
    static skipIdenticalCoordinates(lineString, linePoint) {
        if (lineString.length > 0 && (0, lodash_1.isEqual)(lineString[lineString.length - 1], linePoint)) {
            return lineString;
        }
        return [...lineString, linePoint];
    }
    static checkDuplicateNodes(lineString) {
        const nodes = [];
        for (let i = 0; i < lineString.length; i += 1) {
            if (nodes.length > 0 && (0, lodash_1.isEqual)(nodes[nodes.length - 1], lineString[i])) {
                return true;
            }
            nodes.push(lineString[i]);
        }
        return false;
    }
    static ensureLineStringOrder(lineString) {
        if (lineString.length > 1) {
            return lineString;
        }
        if (lineString.length === 1) {
            lineString.push([lineString[0][0], lineString[0][1] + 0.00000001]);
            return lineString;
        }
        throw new Error('LineString with zero nodes');
    }
}
exports.default = GeoJsonUtils;
const removeConsecutiveDuplicatePoints = (geometry) => {
    // Helper function to check if two coordinates are the same
    function coordinatesAreEqual(coord1, coord2) {
        return coord1[0] === coord2[0] && coord1[1] === coord2[1];
    }
    // Process LineString or MultiLineString geometry
    function processLineString(coordinates) {
        let filteredCoordinates = [coordinates[0]]; // Start with the first point
        for (let i = 1; i < coordinates.length; i++) {
            if (!coordinatesAreEqual(coordinates[i], coordinates[i - 1])) {
                filteredCoordinates.push(coordinates[i]);
            }
        }
        return filteredCoordinates;
    }
    const geomType = geometry.type;
    switch (geomType) {
        case 'LineString':
        case 'MultiPoint':
            geometry.coordinates = processLineString(geometry.coordinates);
            break;
        case 'MultiLineString':
            geometry.coordinates = geometry.coordinates.map(processLineString);
            break;
        case 'Polygon':
            geometry.coordinates = geometry.coordinates.map(processLineString);
            break;
        case 'MultiPolygon':
            geometry.coordinates = geometry.coordinates.map(polygon => polygon.map(processLineString));
            break;
        default:
            (0, helper_1.logMsg)(`Unsupported geometry type for points removal: ${geomType}`);
            break;
    }
};
exports.removeConsecutiveDuplicatePoints = removeConsecutiveDuplicatePoints;
/**
 * This will give us 4 points in all 4 directions from a given point with given bufferValue
 * @param point
 * @param bufferValue
 * @returns 4 points
 */
const getFourCoordinatesFromPoint = (point, bufferValue) => {
    let point1 = (0, lodash_2.cloneDeep)(point);
    let point2 = (0, lodash_2.cloneDeep)(point);
    let point3 = (0, lodash_2.cloneDeep)(point);
    let point4 = (0, lodash_2.cloneDeep)(point);
    point1.coordinates[0] += bufferValue;
    point2.coordinates[0] -= bufferValue;
    point3.coordinates[1] += bufferValue;
    point4.coordinates[1] -= bufferValue;
    return [point1, point2, point3, point4];
};
exports.getFourCoordinatesFromPoint = getFourCoordinatesFromPoint;
